import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../services/api";
import { setToastOk } from "../main/mainSlice";

function showLoginError(dispatch, error) {
  const message = error.response?.data || "Không thể đăng nhập. Vui lòng thử lại.";
  dispatch(setToastOk({ isOk: false, messages: message }));
  return message;
}

export const login = createAsyncThunk(
  "auth/login",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post("/admins/login", payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(showLoginError(dispatch, error));
    }
  },
);

export const verifyAdminOtp = createAsyncThunk(
  "auth/verifyAdminOtp",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post("/admins/verify-otp", payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(showLoginError(dispatch, error));
    }
  },
);

export const authSlice = createSlice({
  name: "auth",
  initialState: {},
  reducers: {},
});

export default authSlice.reducer;
